import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { authToken } from '@wellesley/auth/helpers/token'

import { baseQueryWithLogout } from './helpers/baseQueryWithLogout'
import { baseQueryRetry } from './helpers/baseQueryRetry'
import { baseQueryWithInitialData } from './helpers/baseQueryWithInitialData'
import { QueryTags } from './queryTags'
import { staticState } from '@wellesley/host-remote/common/staticState'
import { microFrontendFetch } from './microFrontendFetch'

const baseUrlParam = staticState.get().baseUrl
export const baseUrl =
  process.env.DOMAIN_ENV === 'dev'
    ? process.env.DEV_API_URL || process.env.DEV_LOCAL_TEST_ME_URL
    : baseUrlParam || ''

const baseQuery = fetchBaseQuery({
  fetchFn: microFrontendFetch(),
  baseUrl,
  responseHandler: (response) => {
    const responseType = response.headers.get('content-type')
    const isJSON = responseType?.startsWith('application/json')

    if (isJSON) {
      try {
        return response.json()
      } catch (error) {
        return response.text()
      }
    } else {
      return response.text()
    }
  },
  prepareHeaders: (headers) => {
    const token = authToken.getToken()

    if (token) {
      headers.set('authorization', `Bearer ${token}`)
    }

    return headers
  },
})

const baseQueryWithWrappers = baseQueryWithLogout(
  baseQueryWithInitialData(baseQueryRetry(baseQuery)),
)

export const groupTagTypes = [
  'Groups',
  'Group_Channels',
  'GroupMembers',
  'GroupMembership',
  'GroupRules',
  'Group_Roles',
  'Group_Join_Requests',
  'Group_Apps',
  'Group_Ai_Agents_Assignments',
]
export const allTagTypes = [
  'Secure',
  'USER_CHANGED',
  'Post',
  'Follow',
  'Settings',
  'UserSettings',
  'RBAC',
  'Rbac_Config',
  'Admin_Apps',
  'Admin_Platform_Data',
  'Admin_Ai_Agents_Assignments',
  'Admin_Users',
  'Admin_Groups',
  'Admin_Audit_Logs',
  'Admin_Reports',
  'Admin_Signup_Requests',
  'Admin_Posts',
  'Admin_Uploads',
  'Admin_Roles',
  'Admin_Jobs_Stats',
  'Admin_Federation',
  'Admin_Domain_Block',
  'Admin_Custom_Emojis',
  'Admin_Domain_Allow',
  'Admin_Link_Service_Configure',
  'Admin_Fasp_Remote_Stats',
  'Admin_Fasp_Remote_Config',
  'Admin_Fasp_Remote_Registrations',
  'Admin_Fasp_Remote_Blocklist',
  'Admin_Fasp_Providers',
  'Admin_Fasp_Defaults',
  'Admin_Embeddings',
  'Ai_Agents',
  'Ai_Agents_Posts',
  'Ai_Models',
  'Ai_Providers',
  'Ai_Providers_Models',
  'User_Apps',
  'Account',
  'Profile',
  'User',
  'Relationship',
  'Bookmarks',
  'Global_Search',
  'Events',
  'Event',
  'EventAttendees',
  'EventMutualAttendees',
  ...groupTagTypes,
  ...Object.values(QueryTags),
]

export const api = createApi({
  tagTypes: allTagTypes,
  reducerPath: 'openapi',
  // keepUnusedDataFor: 180,
  baseQuery: baseQueryWithWrappers,
  endpoints: () => ({}),
})
